import ProfilePage from 'pages/ProfilePage/ProfilePage'

export default ProfilePage
